import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TCountryApi } from './types';

export const country: TCountryApi = {
	getCountryList: () =>
		http.get(endpoint.country.GET_COUNTRY_LIST).then((response) => response.data),
	getCountryPagedList: (payload) =>
		http.post(endpoint.country.COUNTRY_LIST, payload).then((response) => response.data),
	getCountryDetails: (payload) =>
		http.get(endpoint.country.COUNTRY_DETAILS(payload.id)).then((response) => response.data),
	updateCountry: (payload) =>
		http
			.put(endpoint.country.COUNTRY_UPDATE(payload.id), payload.body)
			.then((response) => response.data),
};
